const e = {
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  lineHeight: "body",
  transition: "all"
};
export {
  e as label
};
